export const mainCrdStyleSmallScreen = {
  display: 'flex',
  flex: 5,
  flexShrink: 0,
  flexDirection: 'column',
  padding: '0px 16px 8px 16px',
  gap: '8px',
  overflow: 'unset',
}

export const mainCrdStyle = {
  display: 'flex',
  flex: 5,
  flexShrink: 0,
  flexDirection: 'column',
  padding: '0px 16px 8px 16px',
  gap: '8px',
  overflow: 'auto',
}

export const stackWrapperStyle = {
  flex: 1,
  alignItems: 'flex-end',
  flexDirection: 'row',
  justifyContent: 'space-between',
}

export const stackBoxWrapper = {
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
}

export const boxButtonsWrapper = {
  marginTop: '5px',
  flexDirection: 'row',
  justifyContent: 'flex-end',
}

export const applyBtnStyle = {
  marginLeft: '10px',
}
